import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class GetSubTypesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerInformation/GetSubTypes',
      requesterInfo,
    })
  }

  public async getSubTypes(): Promise<any[]> {
    return await this.getAsync<any[]>()
  }
}
